@let heroBannerList = heroBanners();
@if (heroBannerList?.length) {
  <app-hero-banner id="main" tabindex="-1" [activeBanners]="heroBannerList"></app-hero-banner>
}
<div class="content">
  @if (!isEventShop) {
    <div class="category-links-wrapper">
      <h2 id="categoryTitle">{{ categoriesTitle }}</h2>
      <ul class="category-links unstyled" aria-labelledby="categoryTitle">
        <a id="category-all" class="unstyled-link no-image" [routerLink]="productsUrl">
          <img src="/assets/images/spar/category-all-home.png" alt="" />
          <span class="label">{{ seeAll }}</span>
        </a>
        @for (category of categories$ | async | slice: 0 : maxCategories; track category.id) {
          <a class="unstyled-link" [class.no-image]="!category.imageUrl" [routerLink]="getCategoryUrl(category.id)">
            @if (category.imageUrl) {
              <img [src]="contentUrl + category.imageUrl" alt="" />
            }
            <span class="label">{{ category.name }}</span>
          </a>
        }
      </ul>
    </div>
  }

  @if (primarySection) {
    <div class="deals-wrapper">
      @let link = primarySection.link;
      <div [class.kiosk]="isKiosk" class="deals primary">
        <div class="deals-header">
          <h1>{{ primarySection.title }}</h1>
          @if (link.name) {
            <a [routerLink]="link.url" [queryParams]="link.params">{{ link.name }}</a>
          }
        </div>
        @let products = primarySection.products | async;
        <div
          class="deals-content"
          [class.rows-1]="products.length <= 4"
          [class.rows-2]="4 < products.length && products.length <= 8"
          [class.rows-3]="8 < products.length && products.length <= 12"
          [class.rows-4]="12 < products.length && products.length <= 16"
          [class.rows-5]="16 < products.length"
          [style.--mobile-rows]="products.length > 10 ? 10 : products.length"
        >
          @for (product of products; track $index) {
            <app-product-card [product]="product"></app-product-card>
          }
        </div>
        @if (link.name) {
          <app-text-button [routerLink]="link.url" [queryParams]="link.params" color="accent">
            {{ link.name }}
          </app-text-button>
        }
      </div>
    </div>
  }

  @if (leftBanner || rightBanner) {
    <div class="big-links-wrapper" [class.fill]="isKiosk">
      <h2>{{ title }}</h2>
      <div class="big-links">
        @if (leftBanner) {
          @let sameSiteLink = sameSite(leftBanner.link);
          @if (sameSiteLink) {
            <a class="unstyled-link" [class.no-image]="!leftBanner.image" [routerLink]="sameSiteLink" [target]="leftBanner.target">
              @if (leftBanner.image) {
                <img [src]="contentUrl + leftBanner.image" alt="" aria-hidden="true" />
              }
              <h3>{{ leftBanner.title }}</h3>
              @if (leftBanner.subtitle) {
                <span>{{ leftBanner.subtitle }}</span>
              }
              <app-text-button aria-hidden="true" [tabIndex]="-1">SE MERE</app-text-button>
            </a>
          } @else {
            <a class="unstyled-link" [class.no-image]="!leftBanner.image" [href]="leftBanner.link" [target]="leftBanner.target">
              @if (leftBanner.image) {
                <img [src]="contentUrl + leftBanner.image" alt="" aria-hidden="true" />
              }
              <h3>{{ leftBanner.title }}</h3>
              @if (leftBanner.subtitle) {
                <span>{{ leftBanner.subtitle }}</span>
              }
              <app-text-button aria-hidden="true" [tabIndex]="-1">SE MERE</app-text-button>
            </a>
          }
        }
        @if (rightBanner) {
          @let sameSiteLink = sameSite(rightBanner.link);
          @if (sameSiteLink) {
            <a class="unstyled-link" [class.no-image]="!rightBanner.image" [routerLink]="sameSiteLink" [target]="rightBanner.target">
              @if (rightBanner.image) {
                <img [src]="contentUrl + rightBanner.image" alt="" aria-hidden="true" />
              }
              <h3>{{ rightBanner.title }}</h3>
              @if (rightBanner.subtitle) {
                <span>{{ rightBanner.subtitle }}</span>
              }
              <app-text-button aria-hidden="true" [tabIndex]="-1">SE MERE</app-text-button>
            </a>
          } @else {
            <a class="unstyled-link" [class.no-image]="!rightBanner.image" [href]="rightBanner.link" [target]="rightBanner.target">
              @if (rightBanner.image) {
                <img [src]="contentUrl + rightBanner.image" alt="" aria-hidden="true" />
              }
              <h3>{{ rightBanner.title }}</h3>
              @if (rightBanner.subtitle) {
                <span>{{ rightBanner.subtitle }}</span>
              }
              <app-text-button aria-hidden="true" [tabIndex]="-1">SE MERE</app-text-button>
            </a>
          }
        }
      </div>
    </div>
  }
</div>
